import { components } from "@/services/openapi";

export enum Provider {
	PGHARD = "pghard",
	PPHARD = "pphard",
	JILIHARD = "jilihard",
	JOKERHARD = "jokerhard",
	SAHARD = "sahard",
	EVPHARD = "evphard",
	FCGHARD = "fcghard",
	NLCHARD = "nlchard",
	NEXTSPINHARD = "nextspinhard",
	SEXYHARD = "sexyhard",
}

// Live-casino providers only. SA and SEXY settle from the live dealer feed, so
// there's no RTP engine to configure — the back-office offers play only, no
// ตั้งค่า, and they're hidden from the per-provider RTP game-settings list.
// Every other provider (pg/jili/joker/pp/evp/fcg/nlc) runs through the RTP
// engine (calculate_payoff_v2), so per-provider/per-game settings DO apply and
// must NOT be listed here. Legacy "sa"/"sexy" keys are kept in case a DB row
// hasn't been migrated to the "*hard" naming yet.
export const NON_RTP_PROVIDERS: string[] = [
	Provider.SAHARD,
	Provider.SEXYHARD,
	"sa",
	"sexy",
];

// Live-casino rows in the spin-order history are money LEGS (bet / settle /
// cancel), not slot spins — the history UI branches on this to drop the
// slot-style "สปินที่ 1/2" and the Game Setting tab.
export const isLiveCasinoProvider = (provider?: string): boolean =>
	!!provider && NON_RTP_PROVIDERS.includes(provider);

type Schemas = components["schemas"];

export type GameModel = Schemas["GameModel"];
export type GetGamesRequest = Schemas["GetGamesDto"];
export type GetGamesResponse = Schemas["GameModel"][];
